export enum FabLinkTypeEnum {
  NONE = "none",
  PHONE = "phone",
  SMS = "sms",
  WHATSAPP = "whatsapp",
  EMAIL = "email",
  URL = "url",
}
